// Phone type IDs used throughout the application
export const phoneTypes = {
  // Company phone types
  company: {
    main: 'C3AE9586-6158-4D0D-9FAF-253CB0152F18',
    tollFree: '17057633-4B31-4AE8-BE33-ED27C7FD1B12',
    fax: '2870C5A5-7B3B-49DE-AD57-763EA3BF41D0',
  },
  // Contact phone types
  contact: {
    direct: 'C3AE9586-6158-4D0D-9FAF-253CB0152F18', // Same as company main
    mobile: '511DF006-2CDB-40B5-8D1A-B313C873DD1C',
  },
};

export function getPhoneNumber(phones, type) {
  if (!phones) {
    return '';
  }

  let typeToUse = '';

  if (type == 'main') {
    typeToUse = phoneTypes.company.main;
  } else if (type == 'tollFree') {
    typeToUse = phoneTypes.company.tollFree;
  } else if (type == 'fax') {
    typeToUse = phoneTypes.company.fax;
  } else if (type == 'direct') {
    typeToUse = phoneTypes.contact.direct;
  } else if (type == 'mobile') {
    typeToUse = phoneTypes.contact.mobile;
  }

  const phone = phones.find((phone) => phone.TYPEID === typeToUse);
  const numDisplay = phone?.NUMBERDISPLAY || '';
  if (phone?.EXT) {
    return numDisplay + ' x' + phone.EXT;
  }
  return numDisplay;
}
